import { Facultativo, MedicalCenter, PruebasDiagnosticas } from "./api";

export interface SearchInput extends MedicalCenter, Facultativo {
    address: string;
    name: string;
    distance: string;
    specialist: string;
    details: SearchInputDetail[];
}

export interface SearchInputDetail {
    primary?: boolean;
    text: string;
}

export interface BreadCrumb {
    label: string;
    navTo?: () => void;
    noCapitalize?: boolean;
}

export const LandingServices = [
    {
        icon: 'assets/icons/landing-card.svg',
        title: 'Tarjeta sanitaria digital'
    },
    {
        icon: 'assets/icons/landing-contact.svg',
        title: 'Chat médico'
    },
    {
        icon: 'assets/icons/landing-analytic.svg',
        title: 'Gestión de autorizaciones'
    },
    {
        icon: 'assets/icons/landing-folder.svg',
        title: 'Informes y recetas electrónicas'
    },
    {
        icon: 'assets/icons/landing-centers-doctors.svg',
        title: 'Buscador de centros y médicos'
    },
    {
        icon: 'assets/icons/landing-another-insurances-products.svg',
        title: 'Más'
    },
]

export const LandingAppSteps = [
    {
        title: 'Descárgate la app',
        description: 'Tendrás siempre contigo tu información médica y podrás realizar cualquier trámite.'
    },
    {
        title: 'Busca médicos y centros cercanos',
        description: 'Elige la especialidad que necesites e indica el lugar donde quieres buscar.'
    },
    {
        title: 'Reserva tu cita',
        description: 'Podrás ver la disponibilidad de fechas y reservar la cita directamente desde la app.'
    }
]

export const FullFooterLinks = [
    {
        sectionTitle: 'Nuestros Seguros',
        block1: [
            {
                title: 'Seguros de Coche',
                url: 'https://www.mapfre.es/particulares/seguros-de-coche/'
            },
            {
                title: 'Seguros para Coches Électricos e Híbridos',
                url: 'https://www.mapfre.es/particulares/seguros-de-coches-ecologicos/'
            },
            {
                title: 'Seguros de Coche para Jóvenes',
                url: 'https://www.mapfre.es/particulares/seguros-de-coche-para-jovenes/'
            },
            {
                title: 'Seguros de Moto',
                url: 'https://www.mapfre.es/particulares/seguros-para-motos/'
            },
            {
                title: 'Seguros de Hogar',
                url: 'https://www.mapfre.es/particulares/seguros-de-hogar/'
            },
            {
                title: 'Seguros de Comunidades de Propietarios',
                url: 'https://www.mapfre.es/particulares/seguros-para-comunidades-propietarios/'
            },
        ],
        block2: [
            {
                title: 'Seguros de Salud',
                url: 'https://www.mapfre.es/particulares/seguros-de-salud/'
            },
            {
                title: 'Seguro Dental',
                url: 'https://www.mapfre.es/particulares/seguros-dentales/'
            },
            {
                title: 'Seguros de Decesos',
                url: 'https://www.mapfre.es/particulares/seguros-de-decesos/'
            },
            {
                title: 'Seguros de Viaje',
                url: 'https://www.mapfre.es/particulares/seguros-viaje/'
            },
            {
                title: 'Seguros de Vida',
                url: 'https://www.mapfre.es/particulares/seguros-de-vida/'
            },
            {
                title: 'Seguros para Animales',
                url: 'https://www.mapfre.es/particulares/seguros-animales/'
            },
        ]
    },
    {
        sectionTitle: 'Otras páginas de MAPFRE',
        block1: [
            {
                title: 'Otros portales',
                url: 'https://www.mapfre.es/otros-portales/'
            },
            {
                title: 'Sala de Prensa',
                url: 'https://www.mapfre.com/espacio-de-comunicacion/'
            },
            {
                title: 'Blog de Salud',
                url: 'https://www.salud.mapfre.es/'
            },
            {
                title: 'Blog de Motor',
                url: 'https://www.motor.mapfre.es/'
            },
            {
                title: 'Blog de Hogar',
                url: 'https://www.hogar.mapfre.es/'
            },
            {
                title: 'Blog de Jubilación',
                url: 'https://www.jubilacionypension.com/'
            },
            {
                title: 'Blog Generación Young',
                url: 'https://www.generacionyoung.com/'
            },
            {
                title: 'Video interpretación',
                url: 'https://clientes.mapfre.es/portal/svi/index.html'
            },
            {
                title: 'Sostenibilidad',
                url: 'https://www.mapfre.com/sostenibilidad/'
            },
            {
                title: 'Aplicaciones móviles',
                url: 'https://www.mapfre.es/movil/'
            },
            {
                title: 'Opiniones MAPFRE',
                url: 'https://www.mapfre.es/opiniones-mapfre/'
            },
        ]
    },
    {
        sectionTitle: 'Legal',
        block1: [
            {
                title: 'Normativa',
                url: 'https://www.mapfre.es/normativa/'
            },
            {
                title: 'Accesibilidad',
                url: 'https://www.mapfre.es/accesibilidad/'
            },
            {
                title: 'Advertencias',
                url: 'https://www.mapfre.es/advertencias/'
            },
            {
                title: 'Privacidad y Seguridad',
                url: 'https://www.mapfre.es/privacidad/'
            },
            {
                title: 'Información de interés',
                url: 'https://www.mapfre.es/informacion-de-interes/'
            },
            {
                url: 'https://www.mapfre.es/lopd/'
            }
        ]
    }
]
